import { render, staticRenderFns } from "./OsDesktopKanban.vue?vue&type=template&id=5ca2c9e0&"
import script from "./OsDesktopKanban.vue?vue&type=script&lang=js&"
export * from "./OsDesktopKanban.vue?vue&type=script&lang=js&"
import style0 from "./OsDesktopKanban.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports